import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination } from 'swiper/modules'
import CarouselCardNative from '../../search-spring-carousel/components/CarouselCardNative'
import CarouselCard from '../../search-spring-carousel/components/CarouselCard'

type Props = {
  enabledNavigation?: boolean
  enabledPagination?: boolean
  spaceBetween?: string | number
  slidesPerView?: number | 'auto'
  centerInsufficientSlides?: boolean
  loop?: boolean
  breakpoints?: any
  products: any
  isCardNative?: boolean
  classWrap?: string
  classSlider?: string
  profile?: string
  sku?: string
}

const ProductCarousel = ({
  enabledNavigation = true,
  enabledPagination = false,
  spaceBetween = 0,
  slidesPerView = 4,
  centerInsufficientSlides = true,
  loop = false,
  breakpoints = {},
  products,
  isCardNative = true,
  classWrap = '',
  classSlider = '',
  sku = '',
  profile = ''
}: Props) => {
  const CardComponent = isCardNative ? CarouselCardNative : CarouselCard

  return (
    <div className={classWrap}>
      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={spaceBetween}
        slidesPerView={slidesPerView}
        loop={loop}
        centerInsufficientSlides={centerInsufficientSlides}
        navigation={{
          enabled: enabledNavigation
        }}
        pagination={{
          enabled: enabledPagination,
          clickable: true
        }}
        breakpoints={breakpoints}
      >
        {products.map((product: any) => (
          <SwiperSlide key={product.id} className={classSlider}>
            <CardComponent product={product} profile={profile} sku={sku} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default ProductCarousel
